module.exports = __webpack_public_path__ + "static/media/auth-bg-1.05371463.jpg";